import { Box } from "@chakra-ui/react";
import { useAppSelector } from "hooks/store/hooks";
import React from "react";
import { selectColorThemeMode } from "stores/ui/uiSlice";

const CommonHeaderBox = ({ children, ...props }) => {
  const colorThemeMode = useAppSelector(selectColorThemeMode);
  return (
    <Box
      padding={"15px"}
      height={"70px"}
      display={"flex"}
      alignItems={"center"}
      position={"fixed"}
      w={{ base: "100%", sm: "430px" }}
      background={`${colorThemeMode}_background`}
      zIndex={100}
      px={"15px"}
      {...props}
    >
      {children}
    </Box>
  );
};

export default CommonHeaderBox;
